module.exports = __webpack_public_path__ + "static/img/qq.6bc652a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qq.jpg
// module id = x59L
// module chunks = 1